import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ReactComponent as SearchIcon } from "../../assets/Icons/search.svg";
import { ReactComponent as CloseIcon } from "../../assets/Icons/close.svg";
import {
  connections,
  LOADING,
  treatment_program,
} from "../../constants/common";
import { useNetwork } from "../../contexts/NetWork";
import { InputAdornment, Pagination, Typography } from "@mui/material";
import CardLoader from "../CardLoader";
import UserCard from "../UserCard";
import ReferalModal from "../ReferalModal";
import { useAuth } from "../../contexts/Auth";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 622,
  p: 0,
  overflow: "hidden",
};

const ConnectionsModal = ({
  other = false,
  handleClose,
  selectedUser,
  provider = null,
}) => {
  let timer;
  const { fetchNetwork, fetchStatus, network } = useNetwork();
  // const { account_type } = useAuth();
  const [params, setParams] = useState({
    page: 1,
    search: "",
    provider,
  });

  const [activeUser, setActiveUser] = useState({});
  const [openReferral, setOpenReferral] = useState(false);

  const handleOpenReferralModal = (data) => {
    setActiveUser(data);
    setOpenReferral(true);
  };

  const handleCloseReferralModal = () => {
    setOpenReferral(false);
  };

  const handleSearch = (ev) => {
    setParams((prevState) => ({
      ...prevState,
      search: ev.target.value,
      page: 1,
    }));
  };

  const clearSearch = () => {
    setParams((prevState) => ({
      ...prevState,
      search: "",
      page: 1,
    }));
    if (other) {
      fetchNetwork(
        {
          ...params,
          user_id: selectedUser?.id,
        },
        connections,
        undefined,
        true
      );
    }
  };

  const handlePagination = (_, page) => {
    setParams((prevState) => ({
      ...prevState,
      page,
    }));
  };

  useEffect(() => {
    if (params.search?.length > 2) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (other) {
          fetchNetwork(
            {
              ...params,
              account_type: provider,
              user_id: selectedUser?.id,
            },
            connections,
            undefined,
            true
          );
        }
      }, 1000);
    }
  }, [params.search]);
  useEffect(() => {
    if (other) {
      fetchNetwork(
        {
          ...params,
          account_type: provider,
          user_id:
            provider === treatment_program
              ? selectedUser?.treatment_program_info?.id
              : selectedUser?.id,
        },
        connections,
        undefined,
        true
      );
    }
  }, [params.page, other]);

  return (
    <Modal
      open={other}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Paper
        sx={{
          ...style,
          width: "50%",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "absolute",
          boxShadow: "none",
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            top: 12,
            right: 12,
          }}
        >
          <Typography variant={"h3"} sx={{}}>
            Who {selectedUser?.first_name} Trusts
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon width={20} height={20} />
          </IconButton>
        </Box>
        <TextField
          fullWidth
          placeholder="Search by Therapist Name, Email or Address"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: params.search && (
              <InputAdornment position="end">
                <IconButton
                  onClick={clearSearch}
                  sx={{
                    p: 0,
                    color: "border.dark",
                  }}
                >
                  <CloseIcon width={20} height={20} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            "input:not(textarea)": {
              pt: { xs: 1.75, sm: 1.5 },
              pb: 1.5,
              fontSize: { xs: 12, sm: 14 },
              pl: 0,
            },
          }}
          onChange={handleSearch}
          value={params.search || ""}
          name="search"
        />

        {fetchStatus === LOADING ? (
          <>
            <CardLoader />
            <CardLoader />
            <CardLoader />
            <CardLoader />
          </>
        ) : (
          network.data.map((item) => (
            <UserCard
              key={item.id}
              data={item}
              onReferralClick={handleOpenReferralModal}
              clearSearch={clearSearch}
              enableRemove={other ? false : true}
              enableReferral={
                item.user_referral && item.send_ref ? true : false
              }
              enableConnections={false}
              params={{ ...params, user_id: selectedUser?.id }}
            />
          ))
        )}

        {network.last_page > 1 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              py: 3,
            }}
          >
            <Pagination
              count={network.last_page}
              shape="rounded"
              color="primary"
              onChange={handlePagination}
              page={params.page}
            />
          </Box>
        )}

        <ReferalModal
          open={openReferral}
          onClose={handleCloseReferralModal}
          data={activeUser}
        />
      </Paper>
    </Modal>
  );
};

export default ConnectionsModal;
